import React, { forwardRef } from 'react'
import { IconButton } from '../IconButton/index.js'
import { colors } from '../../tokens/colors.js'

type AudioPreviewProps = {
  isPlaying?: boolean
  size: 'small' | 'regular'
  vidProgress: number
  setVidProgress: (progress: number) => void
  src: string
}

export const AudioPreview = forwardRef<HTMLAudioElement, AudioPreviewProps>(
  ({ isPlaying, size, vidProgress, setVidProgress, src }, ref) => {
    let mediaRef = ref as React.RefObject<HTMLAudioElement>

    return (
      <div
        style={{
          position: 'relative',
          height: '100%',
          width: '100%',
        }}
      >
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            color: colors.neutral80,
          }}
        >
          <IconButton
            icon={isPlaying ? 'pause' : 'play'}
            size={size}
            onClick={() => {
              if (mediaRef?.current?.paused) {
                const audioElements = document.getElementsByTagName('audio')
                for (let i = 0; i < audioElements.length; i++) {
                  audioElements[i].pause()
                }
                mediaRef?.current.play()
              } else {
                mediaRef?.current.pause()
              }
            }}
          />
        </div>
        <audio ref={mediaRef}>
          <source src={src} type="audio/mpeg" />
          <source src={src} type="audio/ogg" />
        </audio>

        {size !== 'small' && (
          <div
            style={{
              position: 'absolute',
              bottom: '8px',
              right: 8,
              left: 8,
              width: 'calc(100% - 16px)',
              height: 4,
              backgroundColor: colors.neutral20Adjusted,
              backdropFilter: 'blur(12px)',
              borderRadius: 4,
            }}
            onClick={(e) => {
              const x = Math.floor(
                (e.nativeEvent.offsetX / e.currentTarget.offsetWidth) * 100,
              )
              setVidProgress(x)
              mediaRef.current.currentTime =
                mediaRef.current.duration * (x / 100)
            }}
          >
            <div
              style={{
                pointerEvents: 'none',
                width: vidProgress + '%',
                height: '100%',
                backgroundColor: colors.neutral100,
                borderRadius: 4,
              }}
            />
          </div>
        )}
      </div>
    )
  },
)
